const DEBUG_PHONE_NUMBER = '+12702664516'

const NOTIFICATION_TYPES = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
}

const SUPPORT_PHONE_NUMBER = '1-833-702-8764'

const QUIQ_PHONE_NUMBER = '1-574-281-9803'

export {
  DEBUG_PHONE_NUMBER,
  NOTIFICATION_TYPES,
  SUPPORT_PHONE_NUMBER,
  QUIQ_PHONE_NUMBER,
}
